export default __webpack_public_path__ + "static/media/st-patricks-day-appbar-tile.ba7b1c10.png";